const htmlLintMessages = {
  "doctype-first":
    "O Doctype deve ser a primeira declaração no documento. Ele informa ao navegador como renderizar a página.",
  "tag-pair":
    "Certifique-se de que todas as tags HTML tenham uma tag de fechamento correspondente.",
  "id-unique":
    "O atributo 'id' deve ser único dentro do documento para evitar conflitos.",
  "tagname-lowercase":
    "Os nomes das tags HTML devem estar em letras minúsculas para manter a consistência.",
  "attr-value-double-quotes":
    "Os valores dos atributos devem estar entre aspas duplas.",
  "img-alt-require":
    "Adicione o atributo 'alt' às imagens para melhorar a acessibilidade.",
  "special-characters-escaped":
    "Os caracteres especiais (<, >) precisam ser escapados para evitar erros de renderização.",
  "tag-self-close":
    "Certifique-se de que tags como <img> estejam devidamente auto-fechadas.",
  "attr-no-duplication":
    "Os atributos não devem ser duplicados no mesmo elemento.",
  "src-not-empty": "Os atributos 'src' e 'href' não devem estar vazios.",
  "tag-must-be-paired":
    "Certifique-se de que todas as tags abertas possuam uma tag de fechamento correspondente.",
  "start-tag-match-failed":
    "O início da tag não corresponde ao final esperado. Verifique a abertura e o fechamento.",
};

/**
 * Se `ruleId` vier `undefined` do back, tentamos deduzir
 * pela mensagem de erro do HTMLHint.
 */
export function deduceHtmlRuleId(message) {
  // Ajuste os includes() conforme a frase exata que seu HTMLHint retorna:
  if (message.includes("Tag must be paired")) {
    // => "tag-pair"
    return "tag-pair";
  } else if (message.includes("Doctype must be declared first")) {
    // => "doctype-first"
    return "doctype-first";
  } else if (message.includes("Special characters must be escaped")) {
    // => "special-characters-escaped"
    return "special-characters-escaped";
  } else if (
    message.includes("start tag match failed") ||
    message.includes("start-tag-match-failed")
  ) {
    // => "start-tag-match-failed"
    return "start-tag-match-failed";
  }
  // Se aparecer outra variação, crie mais ifs:
  // else if (message.includes("Your-other-message")) return "some-other-rule";

  // Se não achou correspondência, retorne null
  return null;
}

export default htmlLintMessages;
